import * as Events from '@core/events';
import { TChildrenOptions, TFields } from '@core/types';
import { getScopedField } from '@core/utils/common';

export const handler = ({
  form,
  payload,
}: Pick<Events.TEventInformation<unknown>, 'form' | 'payload'>) => {
  const extractScopedChildrenFromOptions = (
    opts?: TChildrenOptions,
  ): string[] | undefined => {
    if (
      !opts ||
      !Object.keys(opts).length ||
      (!opts.scopeBlurredChildren &&
        !opts.scopeChangedChildren &&
        !opts.childrenScope)
    )
      return undefined;

    return Object.keys(form.fields).filter((key) => {
      return (
        (opts?.scopeBlurredChildren && form.fields[key].data.blured) ||
        (opts?.scopeChangedChildren && form.fields[key].data.changed) ||
        opts?.childrenScope?.includes(key)
      );
    });
  };

  const fields = getScopedField<TFields>(
    form.fields,
    extractScopedChildrenFromOptions(payload),
  );
  Object.keys(fields).forEach((key) => {
    if (fields[key].fieldValidationsHaveError(true)) {
      fields[key].rehydrate();
    }
  });
};
